import { BlastPayload } from '@types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getLanguage } from 'redux/reducers/users'
import { Logger } from 'utils/logger'

// key - the name of the key to respond to, compared against event.key
// action - the action to perform on key press

export interface TealiumProps {
  blastPageName?: string;
}

export const Tealium: React.FC<TealiumProps> = ({ blastPageName }) => {
  const language = useSelector(getLanguage)

  const waitForUtagToLoadAndSend = (utagViewObject: BlastPayload) => {
    let counter = 0
    const timeout = () => {
      counter++
      if (counter < 5 && !window.utag) {
        setTimeout(() => {
          timeout()
        }, 1000)
      } else if (window.utag) {
        Logger.log(`utag found after ${counter} tries`)
        window.utag.view(utagViewObject)
      } else {
        Logger.log(`no utag was found after ${counter} tries`)
      }
    }
    timeout()
  }

  useEffect(() => {
    if (!blastPageName) {
      Logger.log('No page_name was listed on this page for analytics.')
    }
    if (language) {
      const utagViewObject = {
        content_language: language,
        content_type: 'medicare complaint form page',
        page_name: blastPageName ?? 'no page_name',
        site_domain: window.location.origin,
        site_environment: process.env.REACT_APP_MEDICARE_ENV,
        site_section: 'medicare complaint form'
      } as BlastPayload
      if (window.utag) {
        Logger.log('utag exists')
        window.utag.view(utagViewObject)
      } else {
        Logger.log('no utag, will retry 5 times')
        // only call this once
        waitForUtagToLoadAndSend(utagViewObject)
      }
    }
  }, [language, blastPageName])
  return (<></>)
}
